(function () {
  'use strict';

  var activePanel = null;

  function initReveal() {
    var els = document.querySelectorAll('.pdp-reveal');
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.1 }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  function resetCaffeineSliderVisual(wrap) {
    wrap.querySelectorAll('.pm-caf-fill-zero, .pm-caf-fill-range').forEach(function (el) {
      el.style.animation = 'none';
      el.style.width = '0';
      if (el.classList.contains('pm-caf-fill-range')) {
        el.style.left = '0';
      }
    });
    wrap.querySelectorAll('.pm-caf-pin').forEach(function (el) {
      el.style.animation = 'none';
      el.style.opacity = '0';
      el.style.left = '0';
    });
  }

  function animateCaffeineSlider(wrap) {
    if (!wrap) return;
    wrap.classList.remove('is-animated');
    resetCaffeineSliderVisual(wrap);
    void wrap.offsetWidth;

    var pins = wrap.querySelectorAll('.pm-caf-pin');
    var fills = wrap.querySelectorAll('.pm-caf-fill-zero, .pm-caf-fill-range');
    var nums = wrap.querySelectorAll('.pm-caf-num');

    pins.forEach(function (p) {
      var pct = parseFloat(p.getAttribute('data-pct')) || 0;
      p.style.setProperty('--target-' + (p.classList.contains('pm-caf-pin-r') ? 'right' : 'left'), pct + '%');
    });

    fills.forEach(function (f) {
      var pct = parseFloat(f.getAttribute('data-pct')) || 0;
      if (f.classList.contains('pm-caf-fill-range')) {
        var min = parseFloat(f.getAttribute('data-min')) || 0;
        f.style.setProperty('--target-range', Math.max(0, pct - min) + '%');
        f.style.setProperty('--target-min', min + '%');
      } else {
        f.style.setProperty('--target-zero', pct + '%');
      }
    });

    nums.forEach(function (n) {
      var target = parseInt(n.getAttribute('data-target'), 10) || 0;
      n.textContent = '0';
      if (target === 0) return;
      var duration = 1200;
      var start = performance.now();
      function step(now) {
        var elapsed = now - start;
        var progress = Math.min(elapsed / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        n.textContent = String(Math.round(eased * target));
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });

    requestAnimationFrame(function () {
      wrap.querySelectorAll('.pm-caf-fill-zero, .pm-caf-fill-range, .pm-caf-pin').forEach(function (el) {
        el.style.animation = '';
      });
      wrap.classList.add('is-animated');
    });
  }

  function initFlyouts() {
    var backdrop = document.getElementById('pdp-flyout-backdrop');
    var profileFab = document.getElementById('pdp-profile-fab');
    var nutriFab = document.getElementById('pdp-nutri-fab');
    var profilePanel = document.getElementById('pdp-profile-panel');
    var nutriPanel = document.getElementById('pdp-nutri-panel');
    if (!backdrop) return;

    function closePanel() {
      if (!activePanel) return;
      var fab = activePanel.id === 'pdp-profile-panel' ? profileFab : nutriFab;
      activePanel.classList.remove('is-open');
      backdrop.classList.remove('is-visible');
      if (fab) fab.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      var closing = activePanel;
      activePanel = null;
      setTimeout(function () {
        if (closing.id === 'pdp-profile-panel') {
          var slider = closing.querySelector('[data-caffeine-slider]');
          if (slider) {
            slider.classList.remove('is-animated');
            resetCaffeineSliderVisual(slider);
          }
        }
        closing.hidden = true;
        backdrop.hidden = true;
      }, 400);
    }

    function openPanel(panel, fab) {
      if (!panel || !fab) return;
      if (activePanel && activePanel !== panel) closePanel();
      panel.hidden = false;
      backdrop.hidden = false;
      requestAnimationFrame(function () {
        panel.classList.add('is-open');
        backdrop.classList.add('is-visible');
      });
      fab.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      activePanel = panel;
      panel.querySelectorAll('.pdp-reveal, .psp-profile-card').forEach(function (el) {
        el.classList.add('is-visible');
      });
      panel.querySelectorAll('.psp-profile-card img').forEach(function (img) {
        img.loading = 'eager';
        if (!img.complete || img.naturalWidth === 0) {
          var src = img.getAttribute('src');
          if (src) {
            img.src = '';
            img.src = src;
          }
        }
      });
      if (panel.id === 'pdp-profile-panel') {
        requestAnimationFrame(function () {
          var slider = panel.querySelector('[data-caffeine-slider]');
          animateCaffeineSlider(slider);
        });
      }
    }

    profileFab && profileFab.addEventListener('click', function () {
      if (activePanel === profilePanel) closePanel();
      else openPanel(profilePanel, profileFab);
    });

    nutriFab && nutriFab.addEventListener('click', function () {
      if (activePanel === nutriPanel) closePanel();
      else openPanel(nutriPanel, nutriFab);
    });

    backdrop.addEventListener('click', closePanel);
    document.querySelectorAll('[data-flyout-close]').forEach(function (btn) {
      btn.addEventListener('click', closePanel);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && activePanel) closePanel();
    });

    document.querySelectorAll('.psp-teaser-open-profile, .psp-jump-open-profile').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openPanel(profilePanel, profileFab);
      });
    });

    document.querySelectorAll('.psp-jump-open-nutrition').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openPanel(nutriPanel, nutriFab);
      });
    });

    window.teavityOpenProfilePanel = function () {
      openPanel(profilePanel, profileFab);
    };
  }

  function getHeaderBarBottom() {
    var announcement = document.querySelector('announcement-bar');
    var topbar = document.getElementById('topbar');
    var headerInner = document.getElementById('header-sticky');
    var header = document.querySelector('.section-header header.header');
    var bottoms = [];

    if (announcement) bottoms.push(announcement.getBoundingClientRect().bottom);
    if (topbar) bottoms.push(topbar.getBoundingClientRect().bottom);
    if (headerInner) bottoms.push(headerInner.getBoundingClientRect().bottom);
    if (header) bottoms.push(header.getBoundingClientRect().bottom);

    if (!bottoms.length) return 72;
    return Math.ceil(Math.max.apply(null, bottoms));
  }

  function getHeaderBottom() {
    var barBottom = getHeaderBarBottom();
    var logo = document.querySelector('.header__logo');
    if (!logo) return barBottom;
    return Math.max(barBottom, Math.ceil(logo.getBoundingClientRect().bottom));
  }

  function updatePdpLayout(jump) {
    if (!jump) return { jumpOffset: 72, stuckTop: 72, scrollOffset: 120 };

    var headerBarBottom = getHeaderBarBottom();
    var fullHeaderBottom = getHeaderBottom();
    var jumpHeight = jump.offsetHeight;
    var isStuck = jump.classList.contains('psp-jump--stuck');
    var jumpOffset = isStuck ? headerBarBottom : fullHeaderBottom + 12;
    var stuckTop = headerBarBottom;
    var scrollOffset = headerBarBottom + jumpHeight + 16;

    document.documentElement.style.setProperty('--psp-jump-offset', jumpOffset + 'px');
    document.documentElement.style.setProperty('--psp-jump-stuck-top', stuckTop + 'px');
    document.documentElement.style.setProperty('--psp-scroll-offset', scrollOffset + 'px');

    return {
      jumpOffset: jumpOffset,
      stuckTop: stuckTop,
      scrollOffset: scrollOffset,
      stickyTriggerTop: fullHeaderBottom + 12,
    };
  }

  function scrollToSection(target) {
    var jump = document.querySelector('.psp-jump');
    if (jump) updatePdpLayout(jump);

    var scrollOffset =
      parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue('--psp-scroll-offset')
      ) || 180;
    var top = target.getBoundingClientRect().top + window.scrollY - scrollOffset;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  function initSmoothJump() {
    document.querySelectorAll('.psp-jump-link[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var href = link.getAttribute('href');
        if (!href) return;
        var target = document.querySelector(href);
        if (!target) return;
        e.preventDefault();
        scrollToSection(target);
      });
    });
  }

  function initJumpSticky() {
    var jump = document.querySelector('.psp-jump');
    if (!jump) return;

    var desktopMq = window.matchMedia('(min-width: 1025px)');
    var placeholder = document.createElement('div');
    placeholder.className = 'psp-jump-placeholder';
    placeholder.hidden = true;
    placeholder.setAttribute('aria-hidden', 'true');
    jump.insertAdjacentElement('afterend', placeholder);

    var jumpAnchor = 0;
    var ticking = false;

    function measure() {
      jump.classList.remove('psp-jump--stuck');
      placeholder.hidden = true;
      placeholder.style.height = '';
      updatePdpLayout(jump);
      jumpAnchor = jump.getBoundingClientRect().top + window.scrollY;
    }

    function update() {
      ticking = false;
      var layout = updatePdpLayout(jump);
      var stickyTop = layout.stickyTriggerTop;

      if (!desktopMq.matches) {
        jump.classList.remove('psp-jump--stuck');
        placeholder.hidden = true;
        placeholder.style.height = '';
        return;
      }

      var stuck = window.scrollY + stickyTop >= jumpAnchor;
      var wasStuck = jump.classList.contains('psp-jump--stuck');
      jump.classList.toggle('psp-jump--stuck', stuck);
      if (stuck !== wasStuck) {
        updatePdpLayout(jump);
      }
      if (stuck) {
        placeholder.style.height = jump.offsetHeight + 'px';
        placeholder.hidden = false;
      } else {
        placeholder.hidden = true;
        placeholder.style.height = '';
      }
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }

    measure();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      measure();
      onScroll();
    });

    if (desktopMq.addEventListener) {
      desktopMq.addEventListener('change', function () {
        measure();
        onScroll();
      });
    } else if (desktopMq.addListener) {
      desktopMq.addListener(function () {
        measure();
        onScroll();
      });
    }
  }

  function init() {
    initReveal();
    initFlyouts();
    initSmoothJump();
    initJumpSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
